import React, { memo } from 'react';
import { Eye, Layers } from 'lucide-react';
import ToggleSwitch from '../ToggleSwitch';

/**
 * Template selector component
 */
const TemplateSelector = memo(({ templates, selectedTemplate, onSelect, onPreview }) => {
  const handleTemplateToggle = (template) => {
    if (selectedTemplate && selectedTemplate.id !== template.id) {
      // Will trigger confirmation modal in parent
      onSelect(template, true);
    } else if (selectedTemplate && selectedTemplate.id === template.id) {
      // Deselect
      onSelect(null, false);
    } else {
      // Select new template
      onSelect(template, false);
    }
  };

  return (
    <div className="landing-templates-grid">
      {templates.map((template) => (
        <div
          key={template.id}
          className="landing-template-card"
          style={{ position: 'relative' }}
        >
          <ToggleSwitch
            isActive={selectedTemplate?.id === template.id}
            onToggle={() => handleTemplateToggle(template)}
          />
          <div className="landing-template-preview">
            <img src={template.preview} alt={template.name} loading="lazy" />
            <div className="landing-template-overlay">
              <button
                className="landing-preview-btn"
                onClick={() => onPreview && onPreview(template)}
                aria-label={`Preview ${template.name} template`}
              >
                <Eye size={16} />
                Preview
              </button>
              <button
                className="landing-select-btn"
                onClick={() => handleTemplateToggle(template)}
                aria-label={`${selectedTemplate?.id === template.id ? 'Deselect' : 'Select'} ${template.name} template`}
              >
                <Layers size={16} />
                {selectedTemplate?.id === template.id ? 'Selected' : 'Select'}
              </button>
            </div>
          </div>
          <div className="landing-template-info">
            <h3>{template.name}</h3>
            <p>{template.description}</p>

            <div className="landing-template-features">
              <h4>Features</h4>
              <ul>
                {template.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

            <div className="landing-template-requirements">
              <h4>Requirements</h4>
              <div className="landing-requirements-list">
                {Object.entries(template.requirements).map(([key, value]) => (
                  <div key={key} className="landing-requirement-item">
                    <span className="landing-requirement-label">{key}</span>
                    <span className="landing-requirement-value">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
});

TemplateSelector.displayName = 'TemplateSelector';

export default TemplateSelector;

